// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".restaurant-details-section[data-v-631211d7]{padding:30px 0}@media(min-width:768px){.restaurant-details-section[data-v-631211d7]{padding:50px 0}}.restaurant-map[data-v-631211d7]{margin-bottom:30px}.restaurant-details-block+.restaurant-details-block[data-v-631211d7]{margin-top:60px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
